import PropTypes from 'prop-types';
/**
 * Created by muxo on 01.01.2017.
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router";
import '../../styles/loginForm.css';
import avatar from '../../images/login/avatar_2x.png';

import * as actions from '../../actions/loginActions';
import MnSpinner from "@mnjsplatform/components/lib/common/MnSpinner";
import i18next from "i18next";

class Login extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {login: "", password: ""};

        this.changeLogin = this.changeLogin.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.doLogin = this.doLogin.bind(this);
    }

    componentDidMount() {
    }

    changeLogin(evt) {
        this.setState({login: evt.target.value});
    }

    changePassword(evt) {
        this.setState({password: evt.target.value});
    }

    doLogin(evt) {
        evt.preventDefault();
        this.props.dispatch(actions.loginProcess(this.state.login, this.state.password, this.props.location, this.props.history));
    }

    render() {
        return (
            <div className="container h-100">
                <MnSpinner active={this.props.inProcess}/>
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-md-4">
                        <h1 className="text-center login-title" style={{marginTop:"20px"}}>{i18next.t('Authorization')}</h1>
                        <div className="account-wall">
                            <img className="profile-img"
                                 src={avatar}
                                 alt="avatar"/>
                            <form className="form-signin">
                                <input type="text" className="form-control" placeholder={i18next.t('Login')} required autoFocus
                                       onChange={this.changeLogin} value={this.state.login}/>
                                <input type="password" className="form-control" placeholder={i18next.t('Password')} required
                                       onChange={this.changePassword} value={this.state.password}/>
                                <button className="btn btn-lg btn-primary btn-block" type="submit" style={{color:"#FFF"}}
                                        onClick={this.doLogin} disabled={this.props.inProcess}>
                                    {i18next.t("Login_Placeholder")}
                                </button>
                                <span className="text-danger">{this.props.errorMessage}</span>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    dispatch: PropTypes.func.isRequired,
    errorMessage: PropTypes.string.isRequired,
    inProcess: PropTypes.bool,
    location: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        inProcess: state.loginState.inProcess,
        errorMessage: state.loginState.errorMessage
    };
}

export default withRouter(connect(mapStateToProps)(Login));
